import React, { useState } from "react";
import {
  Button,
  FormControl,
  IconButton,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core/";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import Alert from "@material-ui/lab/Alert";
import { connect } from "react-redux";
import url from "../../constants/URL";
import Lottie from "react-lottie";
import animationData from "../../animations/676-done.json";
import Loading from "../Loading";
import "./switch.css";

const AddItemForm = (props) => {
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [niche, setNiche] = useState("");
  const [model, setModel] = useState("");
  const [quantityCounting, setQuantityCounting] = useState(false);
  const [quantity, setQuantity] = useState(0);

  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  function handleSubmit() {
    setDone(true);
    const imageFile = new FormData();
    imageFile.append("image", image);
    fetch(`${url}/item/image/upload`, {
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      body: imageFile,
    })
      .then((res) => res.json())
      .then(async (imageURL) => {
        var data = {
          name,
          images: [imageURL],
          description,
          price,
          niche,
        };
        if (model !== "") {
          data = {
            ...data,
            model,
          };
        }

        if (quantity !== 0) {
          data = {
            ...data,
            quantity,
          };
        }
        const token = await JSON.parse(
          window.localStorage.getItem("persist:auth")
        ).token;

        fetch(`${url}/${props.auth.seller._id}/add/item`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        })
          .then((res) => {
            setLoading(false);
            setDone(true);
          })
          .catch((e) => {
            setLoading(false);
            alert(e);
          });
      })
      .catch((e) => {
        setLoading(false);
        alert(e);
      });
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  if (loading) {
    return <Loading />;
  }

  if (done) {
    return (
      <div style={{ marginTop: 50 }}>
        <p style={{ textAlign: "center", color: "dodgerblue", fontSize: 22 }}>
          Item added successfully!
        </p>
        <Lottie options={defaultOptions} height={300} width={300} />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 30,
            marginRight: 35,
          }}
        >
          <button
            onClick={() => props.history.push(`/dashboard/${props.auth.seller._id}`)}
            style={{
              borderRadius: 20,
              alignItems: "center",
              fontSize: 20,
              padding: "12px 70px",
              color: "white",
              borderColor: "lawngreen",
              background: "lawngreen",
            }}
          >
            Ok
          </button>
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        textAlign: "center",
        margin: "0 0 20px 0",
        width: "50%",
        margin: "20px auto",
      }}
    >
      <h2>Add Item</h2>

      <ValidatorForm
        onSubmit={() => {
          if (image === "") {
            alert("Upload Image please");
          } else {
            handleSubmit();
          }
        }}
      >
        <div>
          {image === "" ? (
            <div>
              <input
                accept="image/*"
                id="icon-button-file"
                type="file"
                className="form-input"
                onChange={(e) => {
                  var allowedExtensions = /\.(jpg|jpeg|png)$/i;
                  if (!allowedExtensions.exec(e.target.files[0].name)) {
                    alert(
                      "Invalid file type. Only JPG, JPEG and PNG files are allowed."
                    );
                  } else {
                    setImage(e.target.files[0]);
                    setImageURL(URL.createObjectURL(e.target.files[0]));
                  }
                }}
                style={{ display: "none" }}
              />
              <label htmlFor="icon-button-file">
                <IconButton
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <PhotoCamera />
                </IconButton>
              </label>
              <p>Click here to add image</p>
              {/* {this.state.formData.image} */}
            </div>
          ) : (
            <div>
              <img
                src={imageURL}
                style={{ width: 150, height: 150, borderRadius: 30 }}
                alt="Item"
              />
              <input
                accept="image/*"
                id="icon-button-file"
                type="file"
                className="form-input"
                onChange={(e) => {
                  var allowedExtensions = /\.(jpg|jpeg|png)$/i;
                  if (!allowedExtensions.exec(e.target.files[0].name)) {
                    alert(
                      "Invalid file type. Only JPG, JPEG and PNG files are allowed."
                    );
                  } else {
                    setImage(e.target.files[0]);
                    setImageURL(URL.createObjectURL(e.target.files[0]));
                  }
                }}
                style={{ display: "none" }}
              />
              <label htmlFor="icon-button-file">
                <IconButton
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                >
                  <PhotoCamera />
                </IconButton>
              </label>
            </div>
          )}
        </div>
        <br />

        <div className="responsive-input">
          <TextValidator
            fullWidth={true}
            label="name"
            onChange={(e) => setName(e.target.value)}
            name="name"
            value={name}
            validators={["required"]}
            errorMessages={["this field is required"]}
            variant="outlined"
            required
          />
        </div>
        <br />
        <div className="responsive-input">
          <TextValidator
            label="price"
            onChange={(e) => setPrice(e.target.value)}
            name="price"
            value={price}
            validators={["required"]}
            errorMessages={["this field is required"]}
            variant="outlined"
            fullWidth={true}
            required
          />
        </div>
        <br />
        <div className="responsive-input">
          <TextValidator
            label="description"
            onChange={(e) => setDescription(e.target.value)}
            name="description"
            value={description}
            errorMessages={["this field is required"]}
            variant="outlined"
            fullWidth={true}
            required
          />
        </div>
        <br />
        <div className="responsive-input">
          <FormControl fullWidth={true} variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">
              Niche
            </InputLabel>
            <Select
              name="niche"
              label="Niche"
              value={niche}
              onChange={(e) => setNiche(e.target.value)}
              fullWidth={true}
              required
            >
              <MenuItem value="fast_food">Fast Food</MenuItem>
              <MenuItem value="home_accessories">Home Accessories</MenuItem>
              <MenuItem value="womens_fashion">Women's Fashion</MenuItem>
              <MenuItem value="mens_fashion">Men's Fashion</MenuItem>
              <MenuItem value="kids_fashion">Kid's Fashion</MenuItem>
              <MenuItem value="electronics">Electronics</MenuItem>
              <MenuItem value="glasses">Glasses</MenuItem>
              <MenuItem value="watches">Watches</MenuItem>
              <MenuItem value="sports">Sports</MenuItem>
              <MenuItem value="toys">Toys</MenuItem>
              <MenuItem value="perfumes">Perfumes</MenuItem>
              <MenuItem value="masks">Masks</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div
          style={{ display: "flex", alignItems: "center", margin: "10px 0" }}
        >
          <h3 style={{ marginRight: 10 }}>Quantity Counting:&nbsp;</h3>
          <label class="switch">
            <input
              type="checkbox"
              onChange={() => setQuantityCounting(!quantityCounting)}
            />
            <span class="slider round"></span>
          </label>
        </div>
        <p style={{ fontStyle: "italic", margin: "5px 0", textAlign: "left" }}>
          If item is available in specific quantity than turn on the switch.
        </p>

        {quantityCounting && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <h3 style={{ marginRight: 10 }}>Available Quantity:</h3>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(Number(e.target.value))}
              style={{ width: 50 }}
            />
          </div>
        )}
        <br />
        {niche === "glasses" && (
          <div className="responsive-input">
            <FormControl fullWidth={true} variant="outlined">
              <InputLabel id="demo-simple-select-outlined-label">
                3d Model
              </InputLabel>
              <Select
                name="3d Model"
                label="3d Model"
                value={model}
                onChange={(e) => setModel(e.target.value)}
                fullWidth={true}
              >
                <MenuItem value="rayban_aviator_or_vertFlash">
                  Ray Ban RB3025 Aviator Gold
                </MenuItem>
                <MenuItem value="rayban_wayfarer_havane_vert">
                  Ray Ban Wayfarer Tortoise Crystal Brown
                </MenuItem>
                <MenuItem value="rayban_wayfarer_denimOrange_orangeDegrade">
                  Ray-Ban Wayfarer Sunglasses Orange Gradient
                </MenuItem>
                <MenuItem value="rayban_round_gun_vert">
                  A-Roval Women Polarized Metal Sunglasses
                </MenuItem>
                <MenuItem value="rayban_aviator_gun_vert">
                  Women Semi Rimless Sunglasses
                </MenuItem>
                <MenuItem value="rayban_erika_marronArgent_marronVioletDegrade">
                  Ray-Ban Brown Women's Sunglasses
                </MenuItem>
                <MenuItem value="rayban_clubround_noir_vertClassique_g15">
                  Ray-Ban BLACK Frame GREEN Lenses
                </MenuItem>
                <MenuItem value="rayban_boyfriend_noir_marron_degrade">
                  Ray-Ban BLack Frame / Dark Brown Gradient Lens
                </MenuItem>
                <MenuItem value="rayban_chris_gris_argent_argent_ mirroir">
                  Ray-Ban Highstreet Black on RED Grey
                </MenuItem>
                <MenuItem value="rayban_andy_violet_violet_mirroir">
                  Ray-Ban Men's Round Sunglasses Dark Tortoise/Brown
                </MenuItem>
                <MenuItem value="rayban_andy_bleu_bleu_mirroir">
                  Ray-Ban Andy Matte Blue Frame Blue Mirror Non-Polarized
                </MenuItem>
                <MenuItem value="rayban_chris_noir_argent_gris_degrade">
                  Ray-Ban RUBBER BLACK Frame LIGHT GREY GRADIENT DARK GREY
                  Lenses Non-Polarized
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        )}
        <br />
        {error && (
          <Alert
            severity="error"
            style={{ margin: "0 auto 15px auto", width: "40%" }}
          >
            {error}
          </Alert>
        )}

        <Button color="primary" variant="contained" type="submit">
          Submit
        </Button>
      </ValidatorForm>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(AddItemForm);
